import { StringContext } from "../../core/StringContext";
import { StringData } from "../../core/StringData";
import { StringModule } from "../../core/StringModule";
import { StringToolsContainer } from "../../core/StringToolsContainer";
import { StringObject } from "../../objects/StringObject";

/**
 * Module that updates the `--lerp` CSS variable on elements
 * based on current scroll velocity.
 */
export class StringLerp extends StringModule {
  constructor(context: StringContext) {
    super(context);
    this.htmlKey = "lerp";
  }

  /**
   * Resets the `--lerp` value to 0 when scroll stops.
   */
  onScrollStop(): void {
    this.objects.forEach((object) => {
      this.setLerpValue(object, 0);
    });
  }

  /**
   * Updates `--lerp` value for each connected object during scroll.
   */
  onFrame(data: StringData): void {
    const velocity = data.scroll.lerped;
    this.objects.forEach((object) => {
      this.setLerpValue(object, velocity);
    });
  }

  /**
   * Sets the `--lerp` CSS variable on the object.
   */
  private setLerpValue(object: StringObject, value: number): void {
    this.events.emit(`object:lerp:${object.id}`, value);
    object.htmlElement.style.setProperty("--lerp", value.toString());
  }
}
